export interface Alternate {
  id: string;
  key: string;
  type: string;
  color: string;
  label: string;
  notes: string | null;
  status: "new" | "pending" | "accepted" | "rejected" | string;
  accepted: boolean;
  estimate: string;
  created_at: string;
  created_by: string;
  deleted_at: string;
  updated_at: string;
  use_base_bid_markups: boolean;
  value_management_category: string;
}

export const BLANK_ALTERNATE_LABEL: string = "  Base Bid";
